import { createAction } from '@reduxjs/toolkit'

/**
 * Команды журналов — plain actions (F05). Все — только чтения: перечитать
 * журнал, доказательство или расхождения. Начать выдачу заново —
 * `incidentsRestarted` слайса (его же слушает listener и перечитывает снимок).
 */

/** `registerKey: null` — места ещё нет: перечитываются только кассы (может, работа уже начата). */
export const incidentsReloadRequested = createAction<{ resourceId: string; registerKey: string | null }>(
  'aqsi/incidents/reloadRequested',
)
export const recoveryProofReloadRequested = createAction<{ resourceId: string; saleId: string }>(
  'aqsi/incidents/recoveryProofReloadRequested',
)
export const discrepanciesReloadRequested = createAction<{ resourceId: string }>(
  'aqsi/incidents/discrepanciesReloadRequested',
)
